// src/firebase.js
import { initializeApp } from "firebase/app";
import {
  getDatabase,
  ref,
  set,
  push,
  update,
  remove,
  onValue,
  get,
  runTransaction,
} from "firebase/database";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyBQH2WrAThV4GfBggXES7HKVtO-Ax23rMU",
  authDomain: "jauharib-a673c.firebaseapp.com",
  databaseURL: "https://jauharib-a673c-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "jauharib-a673c",
  storageBucket: "jauharib-a673c.firebasestorage.app",
  messagingSenderId: "353180744058",
  appId: "1:353180744058:web:488da324e65c67f478bec3",
  measurementId: "G-JKT0LQYJG8"
};

const app = initializeApp(firebaseConfig);
const database = getDatabase(app);
const storage = getStorage(app);
const auth = getAuth(app);

export {
  database,
  database as realtimeDb,
  ref,
  set,
  push,
  update,
  remove,
  onValue,
  runTransaction,
  get,
  storage,
  auth,
};
